import { Alert, Dialog } from "@/models/general";
import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import { cloneDeep, uniqueId } from "lodash";
import store from "./index";
import { Component } from "vue";

export interface LayoutState {
  globalLoader: boolean;
  contentTitle: string;
  showControls: boolean;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "layout",
})
class Layout extends VuexModule implements LayoutState {
  contentTitle = "";
  globalLoader = false;
  showControls = false;
  loader = false;
  rightDrawer = false;
  rightDrawerComponent: Component | null = null;
  rightDrawerComponentProps: any | null = null;
  dialogModel: any;

  dialog: Dialog = {
    show: false,
    title: "",
    text: "",
    cancelButton: "general.cancel",
    successButton: {
      text: "general.accept",
      type: "primary",
      callback: async (): Promise<null> => {
        return null;
      },
    },
    showCancelButton: true,
    width: null,
  };

  alerts: Alert[] = [];

  get getContentTitle() {
    return this.contentTitle;
  }

  get loaderIsVisible() {
    return this.loader;
  }

  get dialogIsVisible() {
    return this.dialog.show;
  }

  get getDialog() {
    return this.dialog;
  }

  get getAlerts() {
    return this.alerts;
  }

  get rightDrawerIsVisible() {
    return this.rightDrawer;
  }

  get getRightDrawerComponentProps() {
    return this.rightDrawerComponentProps;
  }

  get getDialogModel() {
    return this.dialogModel;
  }

  // get adsadadasdasdaightDrawerComponent() {
  //   console.log(this.rightDrawerComponent);

  //   return this.rightDrawerComponent;
  // }

  @Mutation
  showLoader() {
    this.loader = true;
  }

  @Mutation
  hideLoader() {
    this.loader = false;
  }

  @Mutation
  setContentTitle(value: string) {
    this.contentTitle = value;
  }

  @Mutation
  showDialog() {
    this.dialog.show = true;
  }

  @Mutation
  hideDialog() {
    this.dialog.show = false;
  }

  @Mutation
  setDialog(dialog: Dialog) {
    this.dialog = cloneDeep(dialog);
  }

  @Mutation
  setDialogTitle(title: string) {
    this.dialog.title = title;
  }

  @Mutation
  setDialogText(text: string) {
    this.dialog.text = text;
  }

  @Mutation
  setDialogType(type: string) {
    this.dialog.successButton.type = type;
  }

  @Mutation
  setDialogCallback(callback: () => Promise<null>) {
    this.dialog.successButton.callback = callback;
  }

  @Mutation
  setAlerts(alerts: Alert[] | Alert) {
    const a = Array.isArray(alerts) ? alerts : [alerts];

    a.forEach((item: Alert, idx: number) => {
      a[idx].id = uniqueId("alerts_");
    });

    this.alerts = a;
  }

  @Mutation
  cleanAlerts() {
    this.alerts = [];
  }

  @Mutation
  showRightDrawer() {
    this.rightDrawer = true;
  }

  @Mutation
  hideRightDrawer() {
    this.rightDrawerComponent = null;
    this.rightDrawer = false;
  }

  @Mutation
  setRightDrawerComponent(component: Component) {
    this.rightDrawerComponent = component;
  }

  @Mutation
  setRightDrawerComponentProps(props: any) {
    this.rightDrawerComponentProps = props;
  }

  @Mutation
  unsetRightDrawerComponentProps() {
    this.rightDrawerComponentProps = null;
  }

  @Mutation
  unsetRightDrawerComponent() {
    this.rightDrawerComponent = null;
  }

  @Mutation
  setDialogModel(model: any) {
    this.dialogModel = model;
  }
}

export const LayoutModule = getModule(Layout);
